import React, { useEffect } from "react";

//
import "./nftTerms.component.scss";

interface Props {
  onLoaded: () => void;
}

const NftTerms: React.FC<Props> = (props) => {

  useEffect(() => {
    props.onLoaded();
  }, [])

  return (
    <div className="terms">
      <div className="terms__wrapper">
        <h1>
          HIGHSNOBIETY TERMS & CONDITIONS FOR MINTING AND HOLDING AN HS NFT
        </h1>
        <h2>1. Introduction</h2>
        <p>
          Any functional non-fungible token (“NFT”) running on the Ethereum
          blockchain, which can be or was minted on this website (“HS NFT”), and
          the underlying digital artwork linked to them (“Art”) are subject to
          the following terms and conditions (“these T&Cs”), provided by Titel
          Media GmbH (“Highsnobiety” or “us” or “we”).
        </p>
        <br />
        <h2>2. Website as interface</h2>
        <p>
          This website is not on the blockchain but acts as interface for the
          user (“user” or “you”) to process the first purchase of a HS NFT
          (“minting”) and interact with the related smart contract, and for
          secondary purchasers of a HS NFT, to access these T&C. By using this
          website and/or processing any transaction to purchase on the secondary
          market or hold an HS NFT, you consent to the terms set forth herein.
        </p>
        <br />
        <h2>3. Risk assumption / your responsibility</h2>
        <h4>3.1. Minting and transactions</h4>
        <p>
          You as the person minting can process the minting through this website
          by connecting your crypto wallet and performing and confirming the
          transactions indicated in your wallet. You accept and acknowledge that
          we are not responsible for the validation and confirmation of any
          transaction or contract through your own wallet, but that this happens
          at your own judgment and under your own control. Transactions on the
          blockchain sometimes go wrong and get stuck, while the underlying
          transaction costs (“Gas Fees”) still apply and can be irrevocably
          lost, even in a broken transaction. Highsnobiety does not take any
          liability in such case.
        </p>
        <h4>3.2. Software, blockchain and smart contract</h4>
        <p>
          Since blockchain and web3 software are still new, and we cannot
          guarantee that the code will function as intended and lead to the
          results you expect. Especially, we have no control over the underlying
          infrastructure and the performance and functionality of the Ethereum
          main net and we cannot undo, reverse or restore any transaction. You
          accept responsibility for any risks associated with interacting with
          smart contracts accessible through this website or any other software
          or service related to the minting and the connection of your wallet.
        </p>
        <h4>3.3. Price fluctuations / no investment</h4>
        <p>
          Price fluctuations in NFTs are a typical phenomenon. Given the
          volatility, HS NFTs should not be considered an investment. Nothing on
          this website qualifies or is intended to be an offering of securities
          in any jurisdiction nor does it constitute an offer or an invitation
          to purchase shares, securities or other financial products. We
          consider the HS NFTs to be art projects which may or may not have
          additional utility. It remains your sole responsibility to assure that
          the minting of an HS NFT and the Art is in compliance with laws and
          regulations in your jurisdiction.
        </p>
        <h4>3.4. Legal uncertainty</h4>
        <p>
          NFTs, crypto currencies and blockchain technology are relatively new.
          The regulatory landscape is still mostly unsettled. New regulations,
          court decisions or legislation could have a negative impact on an HS
          NFTs and could in consequence impact their value. You confirm that you
          acknowledge and accept this risk.
        </p>
        <br />
        <h2>4. Rights pertaining to a HS NFT and to the Art </h2>
        <h4>4.1. Ownership of the HS NFT</h4>
        <p>
          With your purchase of a HS NFT, you buy an entry on the Ethereum
          blockchain, which links to a website representing the underlying art
          of the HS NFT (“Art”). The HS NFTs you can mint through our website
          are art projects, not investments. Your rights pertaining to the HS
          NFT are mediated entirely by the smart contract and the Ethereum
          Network: at no point may we seize, freeze, or otherwise modify the
          ownership of any HS NFT.
        </p>
        <h4>4.2. Rights pertaining to the Art; non-commercial license</h4>
        <p>
          Your purchase of an HS NFT buys you and NFT but you do not own the
          intellectual property of the underlying Art. The only rights
          pertaining to the intellectual property of the Art are the following:
          Subject to your full compliance with these T&Cs, we grant you the
          worldwide, royalty-free non-exclusive right to use, copy and display
          the Art for your own personal, non-commercial purposes in any media.
          For clarity, you have no right to monetize the Art in any commercial
          way, including by granting sublicenses in relation to the Art or
          allowing others to use and display the Art. When you offer your HS NFT
          for sale on a platform, website, app or in any other way, you may
          display the Art in the offer and despite the fact that you will want
          to receive a compensation for your HS NFT, we do not consider this a
          commercial use but a personal, non-commercial use. The rights granted
          to you as set forth herein are limited to the time in which you are
          the owner of the related HS NFT. You do not retain any of these rights
          in case you sell the HF NFT, abandon ownership or burn it.
        </p>
        <h4>4.3. Future Transfers of HS NFTs</h4>
        <p>
          You acknowledge that your HS NFT exists only by virtue of the
          ownership record maintained on the Ethereum blockchain. Any transfer
          of HS NFTs occurs within the Ethereum blockchain and not on our
          website. A secondary sales royalty may apply as indicated on the
          relevant platform you may use for the purchase of the HS NFT on
          secondary market. You understand that the license per Section 4.2
          above is only granted to the actual owner of the HS NFT and the
          previous owner (s) will lose all rights with the transfer of the HS
          NFT.
        </p>
        <h4>4.4. No license under Highsnobiety’s trademarks</h4>
        <p>
          For clarity, the purchase of the HS NFT does not grant you any right
          to use our trademarks such as “Highsnobiety” or others. You may,
          however, refer to us as the source of the HS NFT
        </p>
        <br />
        <h2>5. Eligibility and Compliance</h2>
        <p>
          You are solely responsible for determining the legality of your
          actions on or though this website. You represent, (i) that the minting
          in your country of residency is not limited by laws and regulations,
          (ii) that no limitation apply to you as a person (age, criminal record
          etc.) and (iii) that neither the company you may represent nor your
          country of residency are included in any embargo or sanction list and
          you are further not illegally dealing with such entity or country. You
          further represent to act in compliance with your applicable tax
          regulations that may be associated with purchase or sale of a HS NFT
          covered by these T&Cs.
        </p>
        <br />
        <h2>6. Feedback</h2>
        <p>
          You may choose to submit comments, bug reports, ideas or other
          feedback about these T&Cs, an HS NFT project or this website to
          (collectively “Feedback”). By sending us your Feedback, you agree that
          we may use such Feedback in any way we see fit without additional
          compensation. You hereby grant us a perpetual, irrevocable,
          non-exclusive, worldwide license to incorporate and use the Feedback
          for any purpose.
        </p>
        <br />
        <h2>7. Limitation of Liability</h2>
        <p>
          THIS WEBSITE AND ANY RELATED SERVICES AND SOFTWARE INCLUDING
          THIRD-PARTY WEBSITES AND ANY SMART CONTRACT ARE PROVIDED “AS IS”,
          WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
          LIMITED TO THE WARRANTIES OF MERCHANTABILITY OF ANY HS NFT OR THE ART,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
          SHALL THE WE OR THE CREATORS OF THE HS NFT OR THE UNDERLYING ART BE
          LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
          OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          WITH THE THIS WEBSITE, ANY SERVICE, SOFTWARE, THESE T&Cs OR THE USE OR
          OTHER DEALINGS IN THE SOFTWARE. THESE LIMITATIONS APPLY ONLY IN CASE
          THE DAMAGE HAS NOT BEEN CAUSED BY OUR WILLFUL MISCONDUCT OR GROSS
          NEGLIGENCE. IN THE EVENT OUR LIABILITY CANNOT BE LIMITED OR EXCLUDED
          BASED ON APPLICABLE NATIONAL LAWS, OUR LIABILITY FOR DAMAGES WE CAUSED
          SHALL BE LIMITED TO THE LOWER OF THE MINT PRICE OF THE HS NFT IN
          QUESTION OR AN AMOUNT OF FIVE HUNDRED EUROS (EUR 500,00).
        </p>
        <br />
        <h2>8. Disclaimers</h2>
        <p>
          We do not represent or warrant that access to the front-end interface
          will be continuous, uninterrupted, timely, or secure; that the
          information contained in the interface will be accurate, reliable,
          complete, or current; or that this website and the software behind it
          will be free from errors, defects, viruses, or other harmful elements.
        </p>
        <br />
        <h2>9. Fees and Payment </h2>
        <p>
          If you elect to purchase a HS NFT through this website, any financial
          transactions that you engage in will be conducted solely through the
          Ethereum network. We will have no insight into or control over these
          payments or transactions and will have no liability to you or to any
          third party for any claims or damages that may arise as a result of
          any transactions that you engage or any other transactions that you
          conduct via the Ethereum network.
        </p>
        <br />
        <h2>10. Applicable law</h2>
        <p>
          German law applies to these T&Cs and the relationship between you and
          us.
        </p>
        <br />
        <h2>11. Dispute Resolution</h2>
        <h4>11.1. Arbitration</h4>
        <p>
          Should we ever have any dispute with you arising out of or in
          connection with these T&Cs, including without limitation your access
          or use of this website, or to any related HS NFTs, such disputes shall
          be referred to and finally resolved by arbitration under ICC rules (3
          arbitrators, each party determines one, both determine the third
          together). The place of arbitration will be Berlin, Germany. The
          language of the proceedings will be English and may be German if both
          parties are German of fluent in German. The award of the arbitrator
          will be final and binding, and any judgment on the award rendered by
          the arbitrator shall be entered in any court of competent
          jurisdiction. Each party will cover its own fees and costs associated
          with the arbitration proceedings.
        </p>
        <h4>11.2. Injunctive relief</h4>
        <p>
          Notwithstanding the foregoing, we may seek and obtain injunctive
          relief in any jurisdiction in any court of competent jurisdiction WITH
          RESPECT TO ANY DISPUTE ARISING OUT OF OR RELATED TO THESE T&Cs,
          INCLUDING WITHOUT LIMITATION DISPUTES RELATED TO THIS WEBSITE OR ANY
          HS NFTs MINTED THROUGH THE SITE, OR THE SMART CONTRACTS. YOU HEREBY
          EXPRESSLY GIVE UP YOUR RIGHT TO PARTICIPATE AS A MEMBER OF A CLASS OF
          CLAIMANTS IN ANY LAWSUIT, INCLUDING BUT NOT LIMITED TO CLASS ACTION
          LAWSUITS INVOLVING ANY SUCH DISPUTE. FURTHER, SHOULD A COMPETENT COURT
          BE IN THE UNITED STATES OF AMERICA: YOU HEREBY EXPRESSLY GIVE UP YOUR
          RIGHT TO HAVE A TRIAL BY JURY.
        </p>
        <br />
        <h2>12. Modification to these T&Cs</h2>
        <p>
          We reserve the right, in our sole discretion, to modify these T&Cs,
          also after the minting. All modifications become effective when they
          are posted and you can see from the date indicated on the top of this
          page when the last change has been made, if any. Your continued access
          to or use of an HS NFT and the Art after these TCs have been updated
          will constitute your binding acceptance of the relevant updates.
        </p>
        <br />
        <h2>13. Severability</h2>
        <p>
          Should any provision of these T&Cs be invalid, unenforceable or
          otherwise void, this shall have no effect on the remainder of these
          T&Cs. The invalid, unenforceable or otherwise void provision shall be
          deemed replaced by a valid and enforceable provision coming as close
          as legally possible to the invalid, unenforceable or void provision.
        </p>
      </div>
    </div>
  );
};

export default NftTerms;
